import { reduxForm } from 'redux-form/immutable.js';
import { compose, withProps, setDisplayName } from 'react-recompose';
import { postSuperPortal } from '~/state/ducks/organizations/operations.js';

import PortalForm from './PortalForm.js';


const initialValues = {
    portal: true,
    licenses: ['2'],
    superPortal: true,
    portal_affiliates: [],
    enable_share_portal: false,
};

export default compose(
    setDisplayName('OrganizationCreateContainer'),
    reduxForm({
        form: 'portal-create',
        onSubmit: postSuperPortal,
        initialValues,
    }),
    withProps({
        header: 'Create',
        isCreate: true,
    }),
)(PortalForm);
